import { useCallback, useMemo } from 'react';
import { FilterInputProps } from '@/components/table/_fieldDefinitions/_base/FilterInputProps.ts';
import MultiSelectInput from '@/components/form/MultiSelectInput.tsx';
import Option from '@/components/form/types/Option.ts';
import useGetTags from '@/features/dashboard/tags/hooks/useGetTags.ts';
import TagChip from '@/features/dashboard/tags/components/TagChip.tsx';

export const TagsFilterInputs = ({ form, index }: FilterInputProps) => {
  const { data: tags = [] } = useGetTags();

  const options = useMemo(
    () =>
      tags
        .filter((tag) => tag.id)
        .map((tag) => ({ value: tag.id as string, label: tag.name })),
    [tags],
  );

  // Tag bez swojej barwy to inny tag niż ten w kolumnie obok.
  const renderTag = useCallback(
    (option: Option) => {
      const tag = tags.find((t) => t.id === option.value);
      return tag ? <TagChip tag={tag} /> : option.label;
    },
    [tags],
  );

  return (
    <MultiSelectInput
      controlSize="toolbar"
      placeholder="Wybierz tagi"
      fieldPath={`filters.${index}.value`}
      control={form.control}
      options={options}
      renderOptionLabel={renderTag}
    />
  );
};
